import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom, Subscription } from 'rxjs';
import { ConceptInvoicingTypeEnums } from 'src/app/enum/concept-invoicing-enums';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { InvoicingModelDetailImport } from 'src/app/models/imports/invoicing-model-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { InvoicingModelDetailService } from 'src/app/services/invoicing/invoicing-model-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-invoicing-model-detail',
  templateUrl: './import-invoicing-model-detail.component.html',
  styleUrls: ['./import-invoicing-model-detail.component.scss'],
  standalone: false
})
export class ImportInvoicingModelDetailComponent implements OnInit {

  eventFile: any;
  errorinvoicingModelDetailImport: number = 0;
  nameFile: string = '';
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  invoicingModelId: number = 0;
  invoicingModelDetailImport: boolean = false;
  conceptInvoicingType: number = 1;
  suscription: Subscription;
  visibleTxt: boolean = false;
  invoicingModelDetailImportAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;


  constructor(private invoicingModelDetailService: InvoicingModelDetailService,
    private invoiceService: InvoiceService,
    private toastHandlerService: ToastHandlerService,
    public config: DynamicDialogConfig,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.invoicingModelId = inputs.invoicingModelId;
      this.conceptInvoicingType = inputs.conceptInvoicingType;
    });
  }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.invoicingModelDetailImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  downloadErrorsTxt() {
    if (!this.invoicingModelDetailImportAlerts || this.invoicingModelDetailImportAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.invoiceService.exportImportErrors(this.invoicingModelDetailImportAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionDetallesModeloFacturacion_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    const serviceCall = this.conceptInvoicingType === 2
      ? this.invoicingModelDetailService.downloadPurchaseGuideImport()
      : this.invoicingModelDetailService.downloadGuideImport();

    const fileName = this.conceptInvoicingType === 2
      ? "GuiaModelosCompra.docx"
      : "GuiaModelosFacturacion.docx";

    serviceCall.subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = fileName;
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  send() {
    this.invoicingModelDetailImportAlerts = [];
    this.errorinvoicingModelDetailImport = 0;
    this.visibleTxt = false;
    if (isPlatformBrowser(this.platformId)) {
      const input = document.getElementById("fileImport") as any;
      if (!input.files[0]) {
        this.clearInputFile();
        return;
      }
      let isOk: boolean = true;
      const rowsImports = new Array<InvoicingModelDetailImport>;
      let row: InvoicingModelDetailImport;
      let counter: number = 1, consecutiveInvoicingModel: number, conceptInvoicingCode: number, conceptInvoicingCodeAlter: string,
        swAiu: boolean, invoiceNumber: number, saleAccount: string, saleDevolutionAccount: string, rtfTaxCode: string, ivaTaxCode: string;
      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast('error', "El archivo ingresado no tiene registros para importar.");
            this.clearInputFile();
            return;
          }

          rows.splice(0, 1);
          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;
            const modelType = this.conceptInvoicingType === ConceptInvoicingTypeEnums.venta ? 'facturación' : 'compra';

            let ivaTaxCodeValue;
            let rtfTaxCodeValue;
            let ivaColumn;
            let rtfColumn;

            //A. Consecutivo modelo de facturación:
            const valueInvoicingModelConsecutive = element[0];
            if (valueInvoicingModelConsecutive == null || valueInvoicingModelConsecutive === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El consecutivo del modelo de ${modelType} no es válido.`;
              this.invoicingModelDetailImportAlerts.push(alert);
              rowHasError = true;
            }
            consecutiveInvoicingModel = Number(valueInvoicingModelConsecutive);
            if (isNaN(consecutiveInvoicingModel)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El consecutivo del modelo de ${modelType} no es válido.`;
              this.invoicingModelDetailImportAlerts.push(alert);
              rowHasError = true;
            }

            //B. Código Concepto:
            const valueConceptInvoicingCode = element[1];
            if (valueConceptInvoicingCode == null || valueConceptInvoicingCode === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código del concepto de ${modelType} no es válido.`;
              this.invoicingModelDetailImportAlerts.push(alert);
              rowHasError = true;
            }
            conceptInvoicingCode = Number(valueConceptInvoicingCode);
            if (isNaN(conceptInvoicingCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código del concepto de ${modelType} no es válido.`;
              this.invoicingModelDetailImportAlerts.push(alert);
              rowHasError = true;
            }

            if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.venta) {
              //C. Concepto Alternativo:
              conceptInvoicingCodeAlter = element[2] as string;
              if (conceptInvoicingCodeAlter != null && conceptInvoicingCodeAlter.length > 200) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna C. El codigo alternativo: supera el tamaño máximo de caracteres (200)`;
                this.invoicingModelDetailImportAlerts.push(alert);
                rowHasError = true;
              }

              //D. Sw AIU
              if (element[3] as string != "S" && element[3] as string != "N") {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna D. El campo AIU debe ser valores como: S / N.`;
                this.invoicingModelDetailImportAlerts.push(alert);
                rowHasError = true;
              }
              swAiu = element[3] as string === "S";

              //E. Número Factura
              const invoiceNumberValue = element[4];
              if (invoiceNumberValue == null || invoiceNumberValue === "") {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna E. El número de la facutra no es válido.`;
                this.invoicingModelDetailImportAlerts.push(alert);
                rowHasError = true;
              }
              invoiceNumber = Number(invoiceNumberValue);
              if (isNaN(invoiceNumber)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna E. El número de la factura no es válido.`;
                this.invoicingModelDetailImportAlerts.push(alert);
                rowHasError = true;
              }

              //F. Cuenta Venta:
              saleAccount = element[5] as string;
              if (saleAccount != null && saleAccount.length > 10) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna F. La cuenta de venta supera el tamaño máximo de caracteres (10)`;
                this.invoicingModelDetailImportAlerts.push(alert);
                rowHasError = true;
              }

              //G. Cuenta Devolución Venta:
              saleDevolutionAccount = element[6] as string;
              if (saleDevolutionAccount != null && saleDevolutionAccount.length > 10) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna G. La cuenta de devolucion venta supera el tamaño máximo de caracteres (10)`;
                this.invoicingModelDetailImportAlerts.push(alert);
                rowHasError = true;
              }
              ivaTaxCodeValue = element[7];
              rtfTaxCodeValue = element[8];
              ivaColumn = 'H';
              rtfColumn = 'I';
            } else {
              ivaTaxCodeValue = element[2];
              rtfTaxCodeValue = element[3];
              ivaColumn = 'C';
              rtfColumn = 'D';

              conceptInvoicingCodeAlter = "";
              swAiu = false;
              invoiceNumber = 1;
              saleAccount = "";
              saleDevolutionAccount = "";
            }

            //H. Código IVA:
            ivaTaxCode = ivaTaxCodeValue as string;
            if (ivaTaxCode != null && ivaTaxCode.length > 6) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna ${ivaColumn}. El código del iva supera el tamaño máximo de caracteres (6)`;
              this.invoicingModelDetailImportAlerts.push(alert);
              rowHasError = true;
            }

            //I. Código Retefuente:d
            rtfTaxCode = rtfTaxCodeValue as string;
            if (rtfTaxCode != null && rtfTaxCode.length > 6) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna ${rtfColumn}. El código de retefuente supera el tamaño máximo de caracteres (6)`;
              this.invoicingModelDetailImportAlerts.push(alert);
              rowHasError = true;
            }

            if (!rowHasError) {
              row = new InvoicingModelDetailImport(counter, this.invoicingModelId, consecutiveInvoicingModel, conceptInvoicingCode,
                conceptInvoicingCodeAlter, swAiu, invoiceNumber, saleAccount, saleDevolutionAccount, ivaTaxCode, rtfTaxCode);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });

          if (isOk && rowsImports.length > 0) {
            try {
              let response;
              if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.venta) {
                response = await firstValueFrom(this.invoicingModelDetailService.importInvoicingModelDetail(rowsImports));
              } else {
                response = await firstValueFrom(this.invoicingModelDetailService.importPurchaseModelDetail(rowsImports));
              }
              this.loadPreInvoicingModel = response;
              this.invoicingModelDetailImportAlerts = response?.alerts ?? [];
              this.errorinvoicingModelDetailImport = response?.preInvoicingStateId;
              if (this.errorinvoicingModelDetailImport === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR');
              } else if (this.invoicingModelDetailImportAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
              } else {
                this.visibleTxt = false;
                this.invoicingModelDetailImport = true;
                this.close();
                this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
              }
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.warn('Ningún archivo seleccionado:', error)
            }
            this.clearInputFile();
          } else {
            this.errorinvoicingModelDetailImport = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        this.toastHandlerService.showToast('warning', `No ha seleccionado ningún archivo.`, '');
      }
    }
  }
}
